export class BooleanModel {

    constructor(public bool: boolean, public text: string) {
        
    }
}